import React from "react";
type Props = {
    videoId: any;
    videoType: any;
};

const MOLVideoPlayer = ({ videoId, videoType }: Props) => {
    const getUrl = () => {
        switch (videoType) {
            case "VIMEO":
                return `https://player.vimeo.com/video/${videoId}`;
            case "YOUTUBE":
                return `https://www.youtube.com/embed/${videoId}`;
            case "UPLOADED":
                return videoId;
            default:
                return videoId;
        }
    };
    return (
        <iframe
            src={getUrl()}
            width="100%"
            height="360"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="YouTube Video"
        ></iframe>
    );
};

export default MOLVideoPlayer;